export default function overrideExelParams(excelParams: any) {
  const VALIDATION_MESSAGE = 'VALIDATION_MESSAGE';
  const VALIDATION_MESSAGE_JSON = 'VALIDATION_MESSAGE_JSON';
  const SAILOR_OBJECT_ID = 'SAILOR_OBJECT_ID';
  const SAILOR_INSPECTED_OBJECT_TYPE = 'SAILOR_INSPECTED_OBJECT_TYPE';
  const excelParamsUpdated = { ...excelParams };
  if (Array.isArray(excelParamsUpdated.columnKeys)) {
    const index = excelParamsUpdated.columnKeys.indexOf(VALIDATION_MESSAGE);
    if (index !== -1) {
      excelParamsUpdated.columnKeys[index] = VALIDATION_MESSAGE_JSON;
    }
    excelParamsUpdated.columnKeys.push(SAILOR_OBJECT_ID);
    excelParamsUpdated.columnKeys.push(SAILOR_INSPECTED_OBJECT_TYPE);
  }
  return excelParamsUpdated;
}
